import React from 'react';

import { ErrorArea, Form, PasswordInput, ReformSubmitHandler, Submit } from '@kodkafa/reform';

import {
  useAuthControllerResetMutation,
  ResetPasswordDto,
} from '@/store/services/MidleNestApi.service';
import { Link, useNavigate } from 'react-router-dom';
import { errorHandler } from '@/utils/error.handler';
import { useTranslation } from 'react-i18next';
import { useProfile } from '@/hooks';

export default function ResetView() {
  const { t } = useTranslation();
  const [mutation] = useAuthControllerResetMutation();
  const { profile } = useProfile();
  const navigate = useNavigate();
  const handleSubmit: ReformSubmitHandler<ResetPasswordDto> = async (data, setError) => {
    await mutation(data)
      .unwrap()
      .then(() => {
        localStorage.removeItem('accessToken');
        gtag('event', 'reset', { user: profile.id });
        navigate('/login');
      })
      .catch((error) => errorHandler(error, setError));
  };

  return (
    <div className='flex flex-col py-8 mx-auto w-96 text-sm'>
      <h1 className='text-xl font-bold mb-6 text-center'>{t('Reset Your Password')}</h1>
      <Form onSubmit={handleSubmit} className='flex !gap-4'>
        <div>
          <PasswordInput
            name='password'
            label={t('New Password')}
            placeholder={t('password')}
            className='w-full'
            show={<i className='icon-eye px-1.5 cursor-pointer' />}
            hide={<i className='icon-eye-off px-1.5 cursor-pointer' />}
          />
        </div>
        <ErrorArea />
        <div>
          <Submit>{t('Reset')}</Submit>
        </div>
      </Form>

      <hr className='my-4 border-t' />
      <p className='text-center'>
        {t('I guess remember my old password.')}
        <Link to='/login' className='font-bold'>
          {t('Go to Login')}
        </Link>
      </p>
    </div>
  );
}
